// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

/* eslint-disable */
interface IParsedSiteFeature {
  dailyNews: {"enum_constant":"dailyNews","private":false,"configuration_model":null};
  iknowIntegration: {"enum_constant":"iknowIntegration","private":true,"configuration_model":null};
  materials: {"enum_constant":"materials","private":false,"configuration_model":null};
  meetings: {"enum_constant":"meetings","private":false,"configuration_model":"SiteFeature::MeetingsConfig"};
  users: {"enum_constant":"users","private":false,"configuration_model":"SiteFeature::UsersConfig"};
  wordsPage: {"enum_constant":"wordsPage","private":false,"configuration_model":null};
}

export type SiteFeatureId = keyof IParsedSiteFeature;
export type SiteFeatureData = IParsedSiteFeature[SiteFeatureId];
const data: SiteFeatureData[] = [{"enum_constant":"dailyNews","private":false,"configuration_model":null},{"enum_constant":"iknowIntegration","private":true,"configuration_model":null},{"enum_constant":"materials","private":false,"configuration_model":null},{"enum_constant":"meetings","private":false,"configuration_model":"SiteFeature::MeetingsConfig"},{"enum_constant":"users","private":false,"configuration_model":"SiteFeature::UsersConfig"},{"enum_constant":"wordsPage","private":false,"configuration_model":null}];
export default data;
